/**
 * Utility functions for formatting and masks
 */

export const applyPercentageMask = (value) => {
  if (!value) return ''
  
  let cleanValue = value.replace(/\D/g, '')
  
  if (!cleanValue) return ''
  
  const valueInCents = parseInt(cleanValue, 10)
  const valueInPercentage = valueInCents / 100
  
  return valueInPercentage.toLocaleString('pt-BR', {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2
  })
}

export const removePercentageMask = (maskedValue) => {
  if (!maskedValue) return ''
  
  return maskedValue
    .replace(/\./g, '')
    .replace(/,/g, '.')
}

export const applyPriceMask = (value) => {
  if (!value) return ''
  
  let cleanValue = value.replace(/\D/g, '')
  
  if (!cleanValue) return ''
  
  const valueInCents = parseInt(cleanValue, 10)
  const valueInReais = valueInCents / 100
  
  return valueInReais.toLocaleString('pt-BR', {
    style: 'currency',
    currency: 'BRL',
    minimumFractionDigits: 2
  })
}

export const removePriceMask = (maskedValue) => {
  if (!maskedValue) return ''
  
  return maskedValue
    .replace(/R\$\s?/g, '')
    .replace(/\./g, '')
    .replace(/,/g, '.')
}

export const applyFCIMask = (value) => {
  if (!value) return value
  
  const cleanValue = value.replace(/[^a-zA-Z0-9]/g, '')
  
  let masked = cleanValue
  if (cleanValue.length > 8) {
    masked = cleanValue.slice(0, 8) + '-' + cleanValue.slice(8)
  }
  if (cleanValue.length > 12) {
    masked = cleanValue.slice(0, 8) + '-' + cleanValue.slice(8, 12) + '-' + cleanValue.slice(12)
  }
  if (cleanValue.length > 16) {
    masked = cleanValue.slice(0, 8) + '-' + cleanValue.slice(8, 12) + '-' + cleanValue.slice(12, 16) + '-' + cleanValue.slice(16)
  }
  if (cleanValue.length > 20) {
    masked = cleanValue.slice(0, 8) + '-' + cleanValue.slice(8, 12) + '-' + cleanValue.slice(12, 16) + '-' + cleanValue.slice(16, 20) + '-' + cleanValue.slice(20, 32)
  }
  
  return masked
}

export const formatPercentage = (value) => {
  if (!value) return ''
  const numValue = value.toString().replace(/[^\d.,]/g, '')
  return numValue
} 